import { render } from "./UserTable.vue?vue&type=template&id=10235c72&ts=true"
import script from "./UserTable.vue?vue&type=script&lang=ts"
export * from "./UserTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__